<template>
  <div>
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <ContractForm
            ref="baseFormRef"
            @change="changeFormHandler"
            :purchaseQuantity="purchaseQuantity"
            :contractTotalAmount="contractTotalAmount"
            :isDisabledPricingRule="isDisabledPricingRule"
            :fetchFormData="fetchFormData"
            :isDisabledForm="isDisabledForm"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            交易明细
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="card" v-model="tabActiveName" class="common-tab">
            <el-tab-pane label="产品明细" name="first">
              <div class="detail">
                <ContractTable
                  ref="orderDetailListRef"
                  :isRestrict="isRestrict"
                  :orderDetailList="orderDetailList"
                  :detailPageData="fetchFormData"
                  @closeTableHandler="closeTableHandler"
                  @getAmount="getAmount"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="关联明细" name="seconed">
              <div class="detail">
                <RelationInfoTable
                  :isEdit="isEdit"
                  ref="relationInfo"
                  :contractStatus="contractStatus"
                  :defaultData="orderContractRelationshipList"
                ></RelationInfoTable>
              </div>
            </el-tab-pane>
            <el-tab-pane label="付款约定" name="three">
              <div class="detail">
                <DynamicForm
                  key1="paymentRatio"
                  key2="paymentRemind"
                  text1Message="付款比例"
                  text2Message="付款提醒"
                  :initFormData="orderAppointmentList"
                  :isRequiredKey1="true"
                  :isRequiredKey2="false"
                  :requireAtLeastOneRecord="false"
                  ref="orderAppointmentFormRef"
                  :isDisabled="isDisabledForm"
                  errorMessage="请补充付款约定"
                ></DynamicForm>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachmentList"
            :isShowDownBtn="isShowDownBtn"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮组 -->
    <ContractBtn :contractStatus="contractStatus" @btnHandler="btnGroupHandler" />
  </div>
</template>

<script>
  import ContractForm from './components/ContractForm/index.vue';
  import ContractTable from './components/ContractTable/index.vue';
  import ContractBtn from './components/FooterBtnGroup/ContractBtn.vue';
  import RelationInfoTable from './components/RelationInfoTable/index.vue';
  import DynamicForm from '@/pages/purchaseSalesCenter/components/DynamicForm/index.vue';
  import btnMixin from './btnMixin.js';
  import dataMixin from './dataMixin.js';
  import wumaoMixins from '@/common/mixins/wumaoMixins';
  export default {
    name: 'wumaoContractCreate',
    mixins: [btnMixin, dataMixin, wumaoMixins],
    data() {
      return {
        activeNames: ['1', '2', '3'],
        isShowDownBtn: false,
        contractStatus: '',

        tabActiveName: 'first',
        isRestrict: '',
        orderAppointmentList: [],
        purchaseQuantity: 0,
        contractTotalAmount: 0,
        isDisabledPricingRule: null,
        type: 'contract',
      };
    },

    methods: {
      getAmount(value) {
        if (Object.keys(value)[0] == 'purchaseQuantity') {
          this.purchaseQuantity = value['purchaseQuantity'];
        }
        if (Object.keys(value)[0] == 'contractTotalAmount') {
          this.contractTotalAmount = value['contractTotalAmount'];
        }
      },
      // 监听表单变化
      changeFormHandler(formData) {
        console.log(formData, '表单数据');
        this.isRestrict = formData['isRestrict'];
      },
      closeTableHandler(tableData = []) {
        console.log(tableData, '关闭表格统计金额');
        // 处理定价
        const isFixedPriceResult = tableData.some((item) => item.isFixedPrice == '0');
        this.isDisabledPricingRule = isFixedPriceResult;
        console.log(this.isDisabledPricingRule, '当前是否的定价');
      },
      btnGroupHandler(type, params) {
        console.log(type);
        this[type](params);
      },
    },
    components: {
      ContractForm,
      ContractTable,
      ContractBtn,
      RelationInfoTable,
      DynamicForm,
    },
  };
</script>

<style></style>
